import useRequestEffect from "@hooks/useRequestEffect"
import { useMemo } from "react"
import ClubController from "../api/ClubController"

export default () => {
    const [clubs, setClubs] = useRequestEffect(ClubController.index, { cache: "clubs" })
 
    const options = useMemo(() => clubs?.map(club => ({ 
        value: club.id.toString(), 
        label: `${club.name} (${club.members_count} members)`
    })), [clubs])

    return { clubs, options }
}